import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import axios from 'src/axios';
import { APICONSTANTS } from 'src/components/Constants';
import {
  PSEUDO_LANGUAGE,
  isEnglish,
  isPseudoAvailable
} from 'src/i18n/language';

// Custom Backend Config for i18n
const customBackend = {
  type: 'backend',
  read: async function (language, namespace, callback) {
    try {
      // English is the source and the pseudo-locale is generated: neither has
      // a bundle to fetch.
      if (isEnglish(language) || language === PSEUDO_LANGUAGE)
        callback(null, {});
      else {
        const response = await axios.get(
          APICONSTANTS.getTranslations.replace(':lang', language)
        );
        callback(null, response.data);
      }
    } catch (error) {
      callback(null, {});
    }
  }
};

const stored = localStorage.getItem('lang');
// The pseudo-locale is a development check; a production build that finds it
// remembered falls back to English.
const lang = stored === PSEUDO_LANGUAGE && !isPseudoAvailable() ? 'en' : stored;

i18n
  .use(initReactI18next)
  .use(customBackend)
  .init({
    lng: lang || 'en',
    fallbackLng: 'en'
  });

export default i18n;
